const fallbackSchedule = (time: number) => {
  return new Promise<void>((res) => {
    setTimeout(() => res(), time);
  });
};

export const newWorkerScheduler = () => {
  return {
    setTimeout: fallbackSchedule,
  };
};

export const defaultScheduler = newWorkerScheduler();

export const setTimeoutOnWorker = (time: number) => {
  const timeoutPromise = defaultScheduler.setTimeout(time);
  let cancelled = false;
  let cancel: () => void = () => {};
  const promise = new Promise<void>((res, rej) => {
    cancel = rej;
    timeoutPromise.then(() => {
      if (!cancelled) {
        res();
      }
    });
  });
  return {
    promise,
    cancel: () => {
      cancelled = true;
      cancel();
    },
  };
};
